import * as allowedFeaturesConstants from './allowedFeaturesConstants';
import AppService from 'Global/AppService';

const fetchAllowedFeatures = (url) => {
console.log("data::::::::::",url);
    return (dispatch) => {
        dispatch({ type: allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_REQUEST});

        function callback(success, err){
            console.log({success});
            if(success && success.result){
                dispatch(getAllowedFeaturesSuccess(success));
            }else{
                dispatch(getAllowedFeaturesFailure());
            }
        }
        AppService.getData(url, callback);
    }
}

const getAllowedFeaturesSuccess = (successResponse) => {
    return { type: allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_SUCCESS, newState: successResponse };
}

const getAllowedFeaturesFailure = () => {
    return { type: allowedFeaturesConstants.FETCH_ALLOWED_FEATURES_FAILURE};
}

export {
    fetchAllowedFeatures
}
